import { createProjectsApi, ProviderErrorResponse } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';
import type { UnifiedProject } from '@interfaces/IUnifiedProject';

export type { UnifiedProject };

// The shared projects API bound to the web transport (cookie-carrying
// `authedFetch`). Mobile binds the same factory to its Bearer transport.
export const { listProjects, openProject } = createProjectsApi(authedFetch);

export { ProviderErrorResponse };
